export default {
  namespaced: true,

  state: {
    mainName: null,
    subName: null,
    accessToken: null,
    client: null,
    uid: null,
    role: null,
    lastOperatedDate: null,
    userId: null,
    schoolData: null
  },

  getters: {
    isAdmin: state => {
      return state.role === 'Admin'
    },
    isTeacher: state => {
      return state.role === 'Teacher'
    },
    homePath: state => {
      // /admin/home or /teacher/home
      return '/'+state.role.toLowerCase()+'/home'
    }
  },

  mutations: {
    setRole(state, payload) {
      state.role = payload.role;
    },

    setMainName(state, payload) {
      state.mainName = payload.mainName;
    },

    setSubName(state, payload) {
      state.subName = payload.subName;
    },

    setLastOperatedDate(state, payload) {
      state.lastOperatedDate = payload.lastOperatedDate;
    },

    setUserId(state, payload) {
      state.userId = payload.userId;
    },

    setSchoolData(state, payload) {
      state.schoolData = payload.schoolData;
    },

    login(state, payload) {
      state.accessToken = payload.accessToken;
      state.client = payload.client;
      state.uid = payload.uid;
      state.userId = payload.userId;
      state.schoolData = payload.schoolData;
    },

    logout(state) {
      state.accessToken = null
      state.client = null
      state.uid = null
      state.userId = null;
      state.schoolData = null;
    },
  },
}
